import { DateFormatter } from '@repo/toolkit/date'

import { Staff } from './staff'

export class StaffProperties {
  static getSeniority(staff?: Pick<Staff, 'firstInvolvementAt'>): number {
    if (!staff?.firstInvolvementAt) return 0
    return DateFormatter.getYearsDifference(new Date(), staff.firstInvolvementAt) + 1
  }
}
